"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewNode = exports.Relationship = exports.decodeRelationship = exports.GraphNode = exports.decodeNode = void 0;

var unit_1 = require("./unit");

var uuid_1 = require("./support/uuid");

var graph_1 = __importStar(require("./http/graph"));

var modem_1 = require("./modem");

var location_1 = require("./location");

var status_1 = require("./status");

var port_logical_sort_1 = require("./port_logical_sort");

var model_1 = require("./model");

;
/**
 * decodeGraph decodes API-formatted graphs into Graph objects and properly initializes them
 * @param g a raw API-formatted graph to be parsed into a Graph
 */

exports.decodeNode = function (n) {
  var e_1, _a, e_2, _b;

  var unit = unit_1.decodeUnit(n);
  var node = NewNode();
  node.fromUnit(unit);

  if (n.children && n.children.length > 0) {
    try {
      for (var _c = __values(n.children), _d = _c.next(); !_d.done; _d = _c.next()) {
        var r = _d.value;
        node.children.push(exports.decodeRelationship(r));
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }

  if (n.parents && n.parents.length > 0) {
    try {
      for (var _e = __values(n.parents), _f = _e.next(); !_f.done; _f = _e.next()) {
        var r = _f.value;
        node.parents.push(exports.decodeRelationship(r));
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  }

  return node;
};

var GraphNode =
/** @class */
function (_super) {
  __extends(GraphNode, _super);
  /**
   * Create a new Unit
   * @param uuid - The UUID of the unit
   */


  function GraphNode(uuid, assetid, giai, model, version, channel, time, lastSeen, profile, profileversion, deviceType, location, status, lifecycle, modem) {
    if (assetid === void 0) {
      assetid = '';
    }

    if (giai === void 0) {
      giai = '';
    }

    if (model === void 0) {
      model = new model_1.Model('', '', '', model_1.Medium.Other, 0);
    }

    if (version === void 0) {
      version = '';
    }

    if (channel === void 0) {
      channel = '';
    }

    if (profile === void 0) {
      profile = 0;
    }

    if (profileversion === void 0) {
      profileversion = 0;
    }

    if (deviceType === void 0) {
      deviceType = 0;
    }

    if (status === void 0) {
      status = new status_1.Status("unknown", "0");
    }

    if (lifecycle === void 0) {
      lifecycle = new status_1.Status("unknown", "0");
    }

    if (modem === void 0) {
      modem = new modem_1.Modem();
    }

    var _this = _super.call(this, uuid, assetid, giai, model, version, channel, time, lastSeen, profile, profileversion, deviceType, location, status, lifecycle, modem) || this;

    _this.parents = [];
    _this.children = [];
    return _this;
  }

  GraphNode.prototype.fromUnit = function (unit, mustMatch) {
    if (mustMatch === void 0) {
      mustMatch = false;
    }

    if (!mustMatch) {
      this.uuid = unit.uuid;
    }

    _super.prototype.replace.call(this, unit, false);
  };

  GraphNode.prototype.replace = function (node, mustMatch) {
    if (mustMatch === void 0) {
      mustMatch = false;
    }

    if (!mustMatch) {
      this.uuid = node.uuid;
    }

    _super.prototype.replace.call(this, this, false);

    this.children = node.children;
    this.parents = node.parents;
  };

  GraphNode.prototype.virtualLocation = function () {
    var e_3, _a, e_4, _b;

    if (this.location.lat === 0 && this.location.lng === 0) {
      console.log("No local location");

      if (this.parents.length > 0) {
        try {
          for (var _c = __values(this.parents), _d = _c.next(); !_d.done; _d = _c.next()) {
            var parent_1 = _d.value;

            if (parent_1.node.location.lat !== 0 && parent_1.node.location.lng !== 0) {
              return parent_1.node.location;
            }
          }
        } catch (e_3_1) {
          e_3 = {
            error: e_3_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_3) throw e_3.error;
          }
        }
      }

      if (this.children.length > 0) {
        // try kids
        var minLat = 180;
        var maxLat = -180;
        var minLng = 180;
        var maxLng = -180;

        try {
          for (var _e = __values(this.children), _f = _e.next(); !_f.done; _f = _e.next()) {
            var child = _f.value;

            if (child.node.location.lat !== 0 && child.node.location.lng !== 0) {
              if (child.node.location.lat > maxLat) {
                maxLat = child.node.location.lat;
              }

              if (child.node.location.lat < minLat) {
                minLat = child.node.location.lat;
              }

              if (child.node.location.lng > maxLng) {
                maxLng = child.node.location.lng;
              }

              if (child.node.location.lng < minLng) {
                minLng = child.node.location.lng;
              }
            }
          }
        } catch (e_4_1) {
          e_4 = {
            error: e_4_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
          } finally {
            if (e_4) throw e_4.error;
          }
        }

        console.log(maxLat);
        console.log(minLat);
        console.log(maxLng);
        console.log(minLng);
        return new location_1.UnitLocation("", "", (maxLat - minLat) / 2.0 + minLat, (maxLng - minLng) / 2.0 + minLng, "", "", "", "", "", "", "", "");
      }
    }

    return this.location;
  };

  GraphNode.prototype.isAncestor = function (node, us) {
    var e_5, _a;

    if (us === void 0) {
      us = this;
    }

    if (node.uuid.equals(us.uuid)) {
      return true;
    } // are we our own ancestor?


    try {
      for (var _b = __values(us.parents), _c = _b.next(); !_c.done; _c = _b.next()) {
        var parent_2 = _c.value;

        if (!(parent_2.type === 2 || parent_2.type === 6)) {
          return this.isAncestor(node, parent_2.node);
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_5) throw e_5.error;
      }
    }

    return false;
  };

  GraphNode.prototype.addChildren = function (credentials, children, relationType, note, move) {
    var e_6, _a;

    if (move === void 0) {
      move = true;
    }

    var childUUIDS = [];

    try {
      for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
        var child = children_1_1.value;
        childUUIDS.push(child.uuid);
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    return graph_1.addChildren(credentials, this.uuid, childUUIDS, relationType, note, move);
  };

  GraphNode.prototype.toUnitArray = function (includeSelf) {
    var e_7, _a;

    if (includeSelf === void 0) {
      includeSelf = true;
    }

    var units = [];

    if (includeSelf) {
      units.push(this);
    }

    try {
      for (var _b = __values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
        var child = _c.value;
        units.push.apply(units, __spread(child.node.toUnitArray(true)));
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_7) throw e_7.error;
      }
    }

    return units;
  };
  /**
   * Get gets the device from from the API if it exists. This returns a Promise for a Unit or undefined
   * @param fields - Fields is the set of fields used to query the backend
   * @param credentials Credentials holds the authorization credentials for the request
   *
   * @returns
   */


  GraphNode.prototype.get = function (fields, credentials) {
    var _this = this;

    return graph_1.default(credentials, fields, this.uuid).then(function (resp) {
      if (resp.length > 1) {
        console.error("Got more than one graph node when getting a single device from remote with uuid: " + _this.uuid.string());
        console.error(resp);
      }

      var n = exports.decodeNode(resp);

      _this.replace(n);

      return n;
    });
  };

  GraphNode.prototype.summary = function (credentials) {
    return graph_1.summary(credentials, this.uuid).then(function (resp) {
      if (resp == null) {
        return undefined;
      }

      return resp.sort(function (a, b) {
        if (Math.round(a.count / 10) === Math.round(b.count / 10)) {
          return port_logical_sort_1.logicalOrder(a, b);
        }

        return Math.round(b.count / 10) - Math.round(a.count / 10);
      });
    });
  };

  return GraphNode;
}(unit_1.Unit);

exports.GraphNode = GraphNode;

exports.decodeRelationship = function (r) {
  var node = NewNode();

  if (r.node) {
    node = exports.decodeNode(r.node);
  }

  var relationship = new Relationship(node, 0, "");

  if (r.type != null && r.type > 0) {
    relationship.type = r.type;
  }

  if (r.relationType != null && r.relationType > 0) {
    relationship.type = r.relationType;
  }

  if (r.note != null && r.note.length > 0) {
    relationship.note = r.note;
  }

  if (r.time != null && r.time.length > 0) {
    relationship.time = new Date(r.time);
  }

  return relationship;
};

var Relationship =
/** @class */
function () {
  function Relationship(node, type, note, time) {
    this.node = node;
    this.type = type;
    this.note = note;
    this.time = time;
  }

  return Relationship;
}();

exports.Relationship = Relationship;
/*
export class Graph {
  node: GraphNode;
  children: Array<Relationship>;
  parents: Array<Relationship>;

  constructor(node: GraphNode, children: Array<Relationship>, parents: Array<Relationship>) {
    this.node = node;
    this.children = children;
    this.parents = parents;
  }
*/

/**
 * Get gets the device from from the API if it exists. This returns a Promise for a Unit or undefined
 * @param fields - Fields is the set of fields used to query the backend
 * @param credentials Credentials holds the authorization credentials for the request
 *
 * @returns
 */
//export default function (credentials: Credentials, fields: Array<Field>, node?: UUID, time?: Date, limitExpression?: string): Promise<Array<any>> {

/*  get(fields: Array<Field>, credentials: Credentials): Promise<Graph | undefined>  {
    return RemoteGraph(credentials, fields, this.node.uuid).then((resp) => {
      if (resp.length>1) {
        console.error("Got more than one graph node when getting a single device from remote with uuid: "+ this.node.uuid.string());
        console.error(resp);
      }
      const g = decodeGraph(resp);
      this.node = g.node;
      this.children = g.children;
      this.parents = g.parents;
      return g;
    });
  }
}
*/

/**
 * Constructs either an empty graph node or one based on a unit
 * @param unit - An optional unit to base this graph node on
 */

function NewNode(unit) {
  var g = new GraphNode(uuid_1.EmptyUUID());

  if (unit != null) {
    g.fromUnit(unit, false);
  }

  return g;
}

exports.NewNode = NewNode;